import moment from 'moment';

export const getPlanOptionsFromSessionLands = (sessionLands) => {
  if (!(sessionLands && sessionLands.length)) {
    return [];
  }
  
  const planOptions = sessionLands.map((planOption) => {
    const peopleCounts = {
      AD: planOption.AD,  
      SN: planOption.SN,
      OT: planOption.OT,
      ZP: planOption.ZP,
      MD: planOption.MD,
      CA: planOption.CA,
      CB: planOption.CB,
      CC: planOption.CC,  
      IF: planOption.IF,
      DATE: planOption.useDate,
      ADPrice: planOption.ADPrice,
      SNPrice: planOption.SNPrice,
      OTPrice: planOption.OTPrice,
      ZPPrice: planOption.ZPPrice,
      MDPrice: planOption.MDPrice,
      CAPrice: planOption.CAPrice,
      CBPrice: planOption.CBPrice,
      CCPrice: planOption.CCPrice,
      IFPrice: planOption.IFPrice,
    };

    return {
      ...planOption,
      peopleCounts,
    };
  });

  return planOptions;
};

export const getPlanOptionsFromSessionLandsByDate = (sessionLands, date) => {
  if (!(sessionLands && sessionLands.length)) {
    return undefined;
  }

  return sessionLands.filter((planOption) => planOption.peopleCounts.DATE === date);
};

export const getPlanOptionFromPlanOptionsByDate = (planOptions, date) => {
  if (!(planOptions && planOptions.length)) return [];

  const d = date.clone().startOf('day');

  return planOptions.filter((planOption) => {
    
    const pod = moment(planOption.peopleCounts.DATE, 'YYYY-MM-DD').startOf('day');
    return d.isSame(pod, 'day'); // 同日判定は isSame を使う
  });
};